import { inViewMargin } from '@helpers/animate';
import { imageUrl, srcSet } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import * as React from 'react';
import S from './BlockCategoryGrid.styles';
const BlockCategoryGrid = ({ items, anchorId }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.Container, { id: anchorId, ref: refContainer, layout: "fullWidth", "data-inview": inView },
        React.createElement(S.ItemList, null, items.map((item) => (React.createElement(S.Item, { as: item.url ? 'a' : 'div', key: item.id, href: item.url ?? '', target: item.target ?? '' },
            React.createElement(S.ImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Desktop), srcSet: srcSet(item.image, { width: 642, height: 333 }) }),
                    React.createElement("source", { media: from(Device.TabletLarge), srcSet: srcSet(item.image, {
                            width: 342,
                            height: 160,
                        }) }),
                    React.createElement("source", { media: from(Device.MobileLarge), srcSet: srcSet(item.image, {
                            width: 512,
                            height: 239,
                        }) }),
                    React.createElement(S.Image, { alt: item.image.altText, loading: "lazy", src: imageUrl(item.image, {
                            width: 240,
                            height: 112,
                        }), srcSet: srcSet(item.image, {
                            width: 240,
                            height: 112,
                        }) }))),
            React.createElement(S.Title, { id: item.title.replaceAll(/[\W_]+/g, '-').toLowerCase() + '-block-title' }, item.title)))))));
};
export default BlockCategoryGrid;
// 240x112
